function capitalize(str) {
    const lower = str.toLowerCase();
    return str.charAt(0).toUpperCase() + lower.slice(1);
  }
  
  const insertBadgeText = (item) => {
    const container = item.querySelector(".rebuy-product-info");
  
    item.classList.forEach(itemClass => {
      if (itemClass.includes("tag-badge_")) {
        const string = itemClass.split("_");
        const text = string[1].split('-').join(' ');
        const text_capitalize = capitalize(text);
  
        const spanElement = `
          <span class="rebuy-product-text-badges" style="background: #${string[2]};"> ${text_capitalize} </span>
        `
  
        container.insertAdjacentHTML("afterbegin", spanElement);
      }
    });
  }
  
  const addProductBrand = (item) => {
    const container = item.querySelector(".rebuy-product-info");
    const title = container.querySelector(".rebuy-product-title");
  
    item.classList.forEach(itemClass => {
      if (itemClass.includes("tag-marca_")) {
        const brand = itemClass.split("_");
        const formatedBrand = brand[1].replace("-", " ");
  
        const element = `
          <div class="prodcut-brand">
            <span> ${formatedBrand} </span>
          </div>
        `
  
        title.insertAdjacentHTML("beforebegin", element);
      }
    });
  }
  
  const insertDiscount = (item) => {
    const container = item.querySelector(".rebuy-product-info");
  
    if(item.querySelector(".rebuy-money.compare-at") != null) {
      const getpriceCompare = item.querySelector(".rebuy-money.compare-at").textContent;
      const priceSale = item.querySelector(".rebuy-money.sale span:nth-child(2n)").innerHTML;
      const priceCompare  = getpriceCompare.replace("price", "").replace("Original", "").replace(" ", "");
      const formatComparePrice = parseFloat(priceCompare.replace("$", "").replaceAll(".", ""));
      const formatSalePrice = parseFloat(priceSale.replace("$", "").replaceAll(".", ""));
      const discountValue = ((formatComparePrice - formatSalePrice) / formatComparePrice) * 100;
  
      const spanElement = `
        <span class="rebuy-product-offer-badges"> -${discountValue.toFixed(0)}% </span>
      `
  
      container.insertAdjacentHTML("afterbegin", spanElement);
    } else {
      container.insertAdjacentHTML("afterbegin", '<span class="rebuy-product-fix-top"></span>');
    }
  }
  
  const addBadge = () => {
    const carousel = document.querySelectorAll(".selected-for-you");
    if (carousel.length > 0) {
      carousel.forEach(carouselSection => {
        const items = carouselSection.querySelectorAll(".rebuy-product-block");
  
        items.forEach(item => {
          insertBadgeText(item);
          insertDiscount(item);
          addProductBrand(item);
        });
      });
    }
  }
  
  /* setTimeout(() => {
    addBadge();
  }, 2000); */
  
  const carouselElement = document.querySelector(".selected-for-you");
  
  if (carouselElement != null) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "childList") {
          addBadge();
        }
      });
    });
  
    const config = { attributes: true, childList: true, characterData: true };
  
    observer.observe(carouselElement, config);
  }